import type { Plugin } from './plugin'
import { State } from './state'

/**
 * Selectors for the records bulk responsible persons workflow.
 */
export class Selectors {
  /** Whether a bulk responsible persons update is in progress */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isUpdating

  /** Employees being made responsible, as edited by the user */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly employeeIds

  /** Employee to make the primary, as edited by the user */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly primaryEmployeeId

  /** Whether a bulk responsible persons request is in flight */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isSubmitting

  /** Error from the last bulk responsible persons request, if there was one */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(plugin: Plugin) {
    this.isUpdating = plugin.feature.state.project(State.isUpdating)
    this.employeeIds = plugin.feature.state.project(
      state => state.employeeIds ?? [],
    )
    this.primaryEmployeeId = plugin.feature.state.project(
      state => state.primaryEmployeeId,
    )
    this.isSubmitting = plugin.feature.state.project(state => state.isSubmitting)
    this.error = plugin.feature.state.project(state => state.error)
  }
}
